import { useQuery } from 'react-query';

import { getV2ApiOrganisationIdSettings } from 'src/client/spendesk-api';
import { useOrganisationId } from 'src/core/modules/app/hooks/useOrganisationId';

import { type Setting } from '../setting';

const fetchSettings = async (organisationId: string) => {
  const response = await getV2ApiOrganisationIdSettings({
    path: {
      organisationId,
    },
  });

  if (response.statusCode !== 200) {
    throw new Error('Failed to fetch settings');
  }

  return response.body;
};

export const useOrganisationSettings = () => {
  const organisationId = useOrganisationId();
  return useQuery(
    ['settings', organisationId],
    async () => {
      const settings = await fetchSettings(organisationId);
      settings.costCenters.sort((a, b) => a.name.localeCompare(b.name));
      return settings.costCenters.map(
        (costCenter): Setting => ({
          key: costCenter.settingsId ?? costCenter.entities[0].id,
          id: costCenter.settingsId ?? '',
          name: costCenter.name,
          ownerId: costCenter.ownerId,
          viewerIds: costCenter.viewerIds,
          companyIds: costCenter.entities.map((entity) => entity.companyId),
          autoAssignFutureEntities:
            costCenter.autoAssignFutureEntities ?? false,
          entities: costCenter.entities.map((entity) => ({
            costCenterId: entity.id,
            companyId: entity.companyId,
          })),
          status: costCenter.status as Setting['status'],
          type:
            costCenter.settingsId === null ? 'entity-specific' : 'cross-entity',
        }),
      );
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
};
